// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"df576811","770":"07b307a8","864":"6bbed674"}[chunkId] + ".chunk.js";
};